// Canonical origin for the public site.
//
// Hardcoded rather than read from `import.meta.env` on purpose: a dev-project
// deploy (asistent-auto-dev.web.app) should still emit canonicals pointing at
// the live host, so a stray crawl of the dev site consolidates onto prod
// instead of competing with it for the same queries.
//
// Apex, not www — both hosts currently answer 200 (no redirect between them),
// so the canonical tag is what tells Google which one counts.
export const SITE_ORIGIN = "https://asistent-auto.ro";

// Build the absolute canonical URL for a route path.
//
// Normalises the shapes a caller might realistically pass: a missing leading
// slash, a trailing slash, or a path that still carries the `?query` / `#hash`
// it was routed with. Query strings never belong in a canonical here — no
// public marketing route varies its content by search param.
export function canonicalUrl(path: string): string {
  const withoutFragment = path.split(/[?#]/)[0];
  const withLeadingSlash = withoutFragment.startsWith("/")
    ? withoutFragment
    : `/${withoutFragment}`;
  // Root stays "/" so the homepage canonical is "https://asistent-auto.ro/";
  // every other path drops its trailing slash.
  const normalised =
    withLeadingSlash.length > 1
      ? withLeadingSlash.replace(/\/+$/, "")
      : "/";
  return `${SITE_ORIGIN}${normalised}`;
}
